function Resume() {
    return (
        <main>
            <section className="relative py-20 md:pt-32">
                <picture className="pointer-events-none absolute inset-0 -z-10">
                    <img src="img/gradient_dark.jpg" alt="gradient dark" className="h-full w-full" />
                </picture>
                <div className="container relative z-10">
                    <div className="text-center pt-24 text-center">
                        <h1 className="mb-6 font-display text-5xl text-white lg:text-6xl">
                            Resume
                        </h1>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default Resume